import { Checkbox, CheckboxGroup, Col, Heading, Row, TextInput } from '@digitools/honest-react';
import { format } from 'date-fns';
import React from 'react';
import { formatName, formatPhone, validateEmail, validatePhone } from '../../../../utils/validationUtils';
import { BorderLessGrayBox } from 'src/components/Formatting/StyledComponents';
import LanguageToggle from 'src/utils/LanguageToggle';
import { LciValidationLabels } from '../../constants/LciValidationLabels';
const Signature = () => {
    const timestamp = format(new Date(), 'MM/dd/yyyy HH:mm:ss');
    const validateSignatureCheckBox = (value) => {
        return !value || value.length < 1 ? <LanguageToggle en='Signature: please check box to submit' es='Firma: marque la casilla para enviar'/> : undefined;
    };
    return (<>
      <BorderLessGrayBox>
        <Heading elemType='h3' elemStyle='h4'>
          Signature
        </Heading>
      </BorderLessGrayBox>
      <CheckboxGroup field={'checkboxInputs'} label={''} hideLabel={true} validate={validateSignatureCheckBox} validateOnChange={true}>
        <Checkbox required={true} field={'signatureCheckBox'} label={'I certify that the facts as indicated above are true to the best of my knowledge and belief.'}/>
      </CheckboxGroup>
      
      <Row className='mt-3'>
        <Col md={8} sm={12}>
          <TextInput id={'name'} field={'name'} label={'Name'} mask={formatName} validateOnBlur={true} type={'text'} data-private={true} required={true}/>
        </Col>
        <Col md={4} sm={12}>
          <Heading elemType={'h4'} elemStyle={'h5'}>Date Signed</Heading>
          <p style={{ marginTop: 0 }}>{timestamp}</p>
        </Col>
      </Row>
      <Row className='mt-0'>
        <Col md={4} sm={12}>
          <TextInput id={'phone'} data-testid={'phone-input'} field={'phone'} label={'Phone'} data-private={true} mask={formatPhone} validate={(value) => validatePhone(value, LciValidationLabels.phone)} validateOnBlur={true} type={'text'} required={true}/>
        </Col>
        <Col md={4} sm={12}>
          <TextInput id={'email'} data-testid={'email-input'} field={'email'} label={'Email'} data-private={true} validate={(value) => validateEmail(value, LciValidationLabels.email)} validateOnBlur={true} type={'text'} required={true}/>
        </Col>
      </Row>
    </>);
};
export default Signature;
